// Youbora
const eventToInfinity = (eventObject) => {
	//Add name
	var name = eventObject.eventAction

	//Add dimensions
	var dimensions = {}
	dimensions.category = eventObject.eventCategory
	// dimensions.action = eventObject.eventAction
	dimensions.label = eventObject.eventLabel

	//Add values
	var values = {}
	window.youboraAnalyticsPlugin.infinity.fireEvent(name, dimensions, values)
}

const navToInfinity = (navObject) => {
	//Add dimensions
	var dimensions = {}
	dimensions.dimension1 = navObject.dimension1
	dimensions.dimension2 = navObject.dimension2
	dimensions.dimension3 = navObject.dimension3
	dimensions.dimension5 = navObject.dimension5
	dimensions.dimension6 = navObject.dimension6
	dimensions.dimension7 = navObject.dimension7
	dimensions.dimension8 = navObject.dimension8
	dimensions.hitType = navObject.hitType
	dimensions.page = navObject.page

	console.log("Infinity Dimenssion", dimensions);

	window.youboraAnalyticsPlugin.infinity.fireNav(dimensions)
}

const youboraInfinity = (metrics) => {
	console.log("METRICS", metrics);
	if (window.youboraAnalyticsPlugin) {
		// console.log("metrics==?", metrics);
		const { payload } = metrics;
		// console.log("payload==?", payload);
		if (payload.hitType === "pageview") {
			console.log("Infinity Nav", payload);
			navToInfinity(payload)
		} else if (payload.hitType === "event") {
			console.log("Infinity Event", payload);
			eventToInfinity(payload)
		}
	}
}

export default youboraInfinity;


// WEBPACK FOOTER //
// ./src/actions/youboraInfinity.js